import { render, staticRenderFns } from "./add-unsubscribers.vue?vue&type=template&id=e4cd8750&scoped=true"
import script from "./add-unsubscribers.vue?vue&type=script&lang=js"
export * from "./add-unsubscribers.vue?vue&type=script&lang=js"
import style0 from "./add-unsubscribers.vue?vue&type=style&index=0&id=e4cd8750&prod&lang=scss"
import style1 from "./add-unsubscribers.vue?vue&type=style&index=1&id=e4cd8750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4cd8750",
  null
  
)

export default component.exports